// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"0ac685903ff63deaf7ef","452":"603b226e8acd89292a4a","522":"b0819205b0b53eae5a05","551":"e933a9c320c445acc0ed"}[chunkId] + ".js";
};